export default __webpack_public_path__ + "static/media/you-broke-me.474973fd.gif";